import { useCallback, useEffect, useRef } from 'react';

export const useTaskPollingSignal = () => {
  const controllerRef = useRef(new AbortController());

  useEffect(
    () => () => {
      controllerRef.current.abort();
    },
    []
  );

  return useCallback(() => {
    if (controllerRef.current.signal.aborted) {
      controllerRef.current = new AbortController();
    }

    return controllerRef.current.signal;
  }, []);
};
